// extracted by mini-css-extract-plugin
module.exports = {"close":"NotificationsCloseButton_close__2dOZB"};